import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import bankTransactionService from '../services'
import { TransactionQueryKeys } from '../../keys'
import { CancelSmsAutoLogRequest } from '../../types'
import showErrorToast from '@/common/utils/showErrorToast'

export function useMutationCancelSmsAutoLog() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: CancelSmsAutoLogRequest }) =>
			bankTransactionService.cancelSmsAutoLog(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.SMS_AUTO_LOGS],
			})
			toast.success('ยกเลิก SMS สำเร็จ')
		},
		onError: (error) => showErrorToast(error),
	})
}
